var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_vm._m(0),_c('Foot')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../../assets/img/options.jpg"),"alt":""}})])}]

export { render, staticRenderFns }